import React from 'react';
import { UiImageUploader } from '../ui-kit';

/* eslint-disable react/prop-types */
export function UiImageUploaderAdapter({ input, meta, ...rest }) {
  return (
    <UiImageUploader
      {...input}
      {...rest}
      errorMessage={meta.touched ? meta.error || meta.submitError || '' : ''}
    />
  );
}
